import { orderApi } from '../../../lib/orderApi';

export const parseTags = (s) => (s || '').split(',').map((t) => t.trim()).filter(Boolean);

const resizeImage = (file) => new Promise((resolve) => {
  const url = URL.createObjectURL(file);
  const img = new Image();
  img.onload = () => {
    const max = 1200;
    const scale = Math.min(1, max / Math.max(img.width, img.height));
    const canvas = document.createElement('canvas');
    canvas.width = Math.round(img.width * scale);
    canvas.height = Math.round(img.height * scale);
    canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
    canvas.toBlob((blob) => { URL.revokeObjectURL(url); resolve(blob || file); }, 'image/jpeg', 0.85);
  };
  img.onerror = () => { URL.revokeObjectURL(url); resolve(file); };
  img.src = url;
});

export const uploadProductImage = async (file) => {
  const blob = await resizeImage(file);
  const fd = new FormData();
  fd.append('file', blob, 'photo.jpg');
  const { data } = await orderApi.post('/admin/products/upload-image', fd);
  return data.url;
};

export const cfgInput = { background: '#0A0A0A', border: '1px solid rgba(201,168,76,0.25)', color: '#F5F5F0', padding: '9px 11px', fontSize: '13px', outline: 'none', width: '100%' };
